import { ProductBadgeSize, ProductBadgeType } from '../../../../features/ProductList/type';
import klass from './styles/ProductBadge.module.scss';
import { compact, join, pipe, values } from '@fxts/core';
import { ProductBadgeBaseData } from './ProductBadgeBase';
import { font, staticFont } from '../../../../shared/typography';

export class ProductBadgeStyleHelper {
  readonly identifier: string;

  public static getBaseTypo(size: ProductBadgeSize): string {
    const typoMap: Record<ProductBadgeSize, string> = {
      [ProductBadgeSize.xLarge]: font('16_bold'),
      [ProductBadgeSize.large]: font('14_bold'),
      [ProductBadgeSize.medium]: font('14_medium'),
      [ProductBadgeSize.small]: font('10_medium'),
    };
    return typoMap[size];
  }

  public static getRankingTypo(size: ProductBadgeSize): string {
    const typoMap: Record<ProductBadgeSize, string> = {
      [ProductBadgeSize.xLarge]: staticFont('bebas_16_bold'),
      [ProductBadgeSize.large]: staticFont('bebas_14_bold'),
      [ProductBadgeSize.medium]: staticFont('bebas_14_bold'),
      [ProductBadgeSize.small]: staticFont('bebas_12_bold'),
    };
    return typoMap[size];
  }

  private readonly style: {
    padding: string;
    ratio: string;
    size: string;
  };

  private readonly icon: {
    base: string;
    size: string;
  };

  constructor(_: ProductBadgeType, { option }: ProductBadgeBaseData) {
    this.identifier = klass.product_badge;

    const ratio = option.ratio === 'square' ? klass.square : '';

    const size = ((): string => {
      if (option.size === 'xLarge') return klass.xLarge;
      if (option.size === 'large') return klass.large;
      if (option.size === 'medium') return klass.medium;
      if (option.size === 'small') return klass.small;
      return '';
    })();
    const padding = ''; // klass.horizontal_padding4;

    this.style = { padding, ratio, size };

    this.icon = {
      base: klass.icon,
      size: (() => {
        if (option.size === 'xLarge' || option.size === 'large') return klass.large;
        if (option.size === 'medium' || option.size === 'small') return klass.medium;
        return '';
      })(),
    };
  }

  get klass(): string {
    return pipe(values(this.style), compact, join(' '));
  }

  get icon_klass(): string {
    return pipe(values(this.icon), compact, join(' '));
  }
}
